import _objectSpread from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import LoginForm from "_c/login-form/login-form";
import LoginFormEnterprise from "_c/login-form/login-form-enterprise";
import { mapActions, mapMutations } from "vuex";
import notices from "./notices";
import { get_website_data } from "@/api/chuku";
import logoimg from "@/assets/images/logo-max.png";
import Language from "@/components/main/components/language";
import config from "@/config";
export default {
  data: function data() {
    return {
      loginWrapper: "loginWrapper",
      account_type: 1,
      //默认开发者帐号
      logoimg: logoimg,
      config: config,
      name: "沛城"
    };
  },
  components: {
    LoginForm: LoginForm,
    LoginFormEnterprise: LoginFormEnterprise,
    Language: Language
  },
  computed: {
    local: function local() {
      return this.$store.state.app.local;
    }
  },
  methods: _objectSpread({}, mapMutations(["setLocal"]), mapActions(["handleLogin", "getUserInfo"]), {
    setLocal: function setLocal(lang) {
      this.$store.commit('setLocal', lang);
      console.log('当前语言:', lang); // 打印切换的语言值
    },
    onClickTabs: function onClickTabs(name) {
      if (name === "name1") {
        this.account_type = 1;
      } else if (name === "name2") {
        this.account_type = 2;
      }
    },
    handleSubmit: function handleSubmit(_ref) {
      var _this = this;

      var userName = _ref.userName,
          password = _ref.password;
      console.log('this.$i18n.locale', this.$i18n.locale);
      this.$refs.loginForm.setLoading(true);
      var admin_lang_type;

      if (this.$i18n.locale == 'en-US') {
        admin_lang_type = 'en';
      } else {
        admin_lang_type = 'zh';
      }

      this.handleLogin({
        userName: userName,
        password: password,
        account_type: this.account_type,
        admin_lang_type: admin_lang_type
      }).then(function (res) {
        if (res.result === 0) {
          localStorage.setItem("country_code", "xciot-prod-cnsz");

          _this.$Message.success(res.errorMsg);

          _this.$router.push({
            name: _this.$config.homeName
          });

          _this.$refs.loginForm.setLoading(false);
        } else {
          _this.$refs.loginForm.setLoading(false);

          _this.$Message.error(res.errorMsg);
        }
      });
    },

    /**
     * 企业员工提交
     * @param userName
     * @param password
     */
    handleSubmitEnterprise: function handleSubmitEnterprise(_ref2) {
      var _this2 = this;

      var userName = _ref2.userName,
          password = _ref2.password;
      this.$refs.loginForm2.setLoading(true);
      this.handleLogin({
        userName: userName,
        password: password,
        account_type: this.account_type,
        admin_lang_type: admin_lang_type
      }).then(function (res) {
        if (res.result === 0) {
          _this2.$Message.success(_this2.$t('登录成功'));

          _this2.$router.push({
            name: _this2.$config.homeName
          });

          _this2.$refs.loginForm2.setLoading(false);
        } else {
          _this2.$refs.loginForm2.setLoading(false);

          _this2.$Message.error(res.errorMsg);
        }
      });
    },
    viewNotice: function viewNotice() {
      var vm = this;
      var config = {
        title: "隐私政策",
        loading: true,
        width: 800,
        render: function render(h) {
          return h(notices, {
            props: {
              $store: vm.$store
            }
          });
        },
        onOk: function onOk() {
          vm.$Modal.remove();
        }
      };
      this.$Modal.success(config);
    }
  }),
  mounted: function mounted() {
    var _this3 = this;

    // 设置初始语言
    this.setLocal(this.$i18n.locale);
    console.log("登录信息", this.$i18n.locale);
    get_website_data().then(function (res) {
      console.log("登录信息", res.body.logo_url);
      localStorage.setItem('logo_url', res.body.logo_url);

      if (_this3.$i18n.locale == "zh-CN") {
        _this3.name = res.body.web_name[0].zh;
      }

      if (_this3.$i18n.locale == "en-US") {
        _this3.name = res.body.web_name[0].en;
      }
    });
  }
};